import React from 'react';
import {Editors, Formatters, Filters } from 'react-data-grid-addons';
import DollarFormatter, {EditableDollarFormatter, PreviewDollarFormatter} from '../DollarFormatter';

import NumberFormmater from '../NumberFormatter';

import ZipCodeEditor from '../ZipCodeEditor';
import {statesValue} from '../../lib/states';

const { AutoComplete: AutoCompleteEditor, DropDownEditor } = Editors;
const { DropDownFormatter } = Formatters;

const StatesEditor = <DropDownEditor key="123" options={statesValue}/>;
const StatesFormatter = <DropDownFormatter options={statesValue} value="AL"/>;
const zipCodeEditor = <ZipCodeEditor/>;


export default {
  baseRatesDataColumns: [
    {
      key: "destination",
      name: "Destination",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "state",
      name: "State",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.MultiSelectFilter
    },
    {
      key: "zip",
      name: "Zip",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter
    },
    {
      key: "rate",
      name: "Current Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    },
    {
      key: "baseRate",
      name: "Base Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    }
  ],
  baseRatePreviewColumns : [
    {
      key: "destination",
      name: "Destination",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "state",
      name: "State",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.MultiSelectFilter
    },
    {
      key: "zip",
      name: "Zip",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter
    },
    {
      key: "rate",
      name: "Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    }, {
      key: "newRate",
      name: "New Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: PreviewDollarFormatter
    }
  ],  
  baseRateEditColumns : [
    {
      key: "destination",
      name: "Destination",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "state",
      name: "State",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.MultiSelectFilter
    },
    {
      key: "zip",
      name: "Zip",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter
    },
    {
      key: "rate",
      name: "Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    },
    {
      key: "newRate",
      name: "New Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: EditableDollarFormatter
    }
  ],
  baseRateAddColumns : [
    {
      key: "destination",
      name: "Destination",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
    },
    {
      key: "state",
      name: "State",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
      editor: StatesEditor,
      formatter: StatesFormatter
      //filterRenderer: Filters.MultiSelectFilter
    },
    {
      key: "zip",
      name: "Zip",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
      filterRenderer: Filters.NumericFilter,
      editor:zipCodeEditor
      //formatter: NumberFormmater
    },
    {
      key: "rate",
      name: "Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    },
    {
      key: "baseRate",
      name: "Base Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      editable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: EditableDollarFormatter
    }
  ]
};


// WEBPACK FOOTER //
// ./src/components/BaseRates/table_columns.js